"use client"

import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"
import { MobileRestriction } from "./mobile-restriction"

const MARKETING_ROUTES = [
    "/discover",
    "/aboutus",
    "/contact",
    "/faqs",
    "/features",
    "/gdpr",
    "/pricing",
    "/privacy-policy",
    "/products",
    "/resources",
    "/terms-of-service",
    "/use-cases",
    "/view"
]

export function MobileRestrictionWrapper({ children }: { children: React.ReactNode }) {
    const pathname = usePathname()
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768)
        }
        
        checkMobile()
        window.addEventListener("resize", checkMobile)
        return () => window.removeEventListener("resize", checkMobile)
    }, [])

    // If it's a marketing route, allow it on mobile
    if (MARKETING_ROUTES.some(route => pathname === route || pathname.startsWith(route + "/"))) {
        return <>{children}</>
    }

    // For all other routes (including /, login, signup, dashboard, etc.), show restriction on mobile
    if (isMobile) {
        return <MobileRestriction />
    }

    return <>{children}</>
}
